import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_9.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/cultivating');
  const shareText = encodeURIComponent('Cultivating a Learning-First Culture!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Cultivating Culture — Outstanding Workplaces</title>
        <meta property="og:title" content="Cultivating Culture — Outstanding Workplaces" />
        <meta property="og:description" content="Cultivating a Learning-First Culture" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777981004/i_9_bozxix.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/foster" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Cultivating Culture — Outstanding Workplaces" />
        <meta name="twitter:description" content="Cultivating a Learning-First Culture" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777981004/i_9_bozxix.jpg" />
      </Helmet>

       <div className="sight_9_page_wrapper">
      <div className="sight_9_content_container">

        <div className="sight_9_section_one">

          {/* TITLE */}
          <h1 className="sight_9_page_title">
            Cultivating a Learning-First Culture
          </h1>

          {/* ROW */}
          <div className="sight_9_row">

            {/* LEFT SIDE */}
            <div className="sight_9_left">
              <div className="sight_9_image_wrapper">
                <img
                  src="/assets/i_9.jpg"
                  alt="Team meeting discussion"
                  className="sight_9_blog_image"
                />
              </div>


                {/* SHARE SECTION */}
                <div className="sight_9_share_section">
                  <span className="sight_9_share_text">Share :</span>
                  <div className="sight_9_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_9_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_9_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_9_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_9_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

             <p className="sight_9_intro_paragraph">
                In today’s fast-evolving business landscape, continuous learning is at the heart of thought leadership and a strong workplace culture. Organizations that prioritize learning empower employees to stay ahead of industry trends, adapt to change, and innovate with confidence. This culture of curiosity not only enhances individual growth but also strengthens collective intelligence, fostering a workplace where ideas flourish, collaboration thrives, and leaders emerge organically.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_9_right">
              <div className="sight_9_ad_card">
                <img src="/assets/bc_1.png" className="sight_9_ad_bg" />
                <div className="sight_9_ad_overlay"></div>

                <img src="/assets/bg_1.png" className="sight_9_ad_badge" />

                <div className="sight_9_ad_content">
                  <h2>
                    Earn the Outstanding <br />
                    <span>Workplaces Certification</span>
                  </h2>

                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>

                    <button 
  className="sight_9_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* SECTION TWO */}
        <div className="sight_9_section">

          <ul className="sight_9_intro_list">
            <li>
              By embedding continuous learning into your organizational DNA, you cultivate both leaders and a culture that can navigate uncertainty, inspire innovation, and set new benchmarks in excellence.
            </li>
          </ul>

          <div className="sight_9_topics">

            <div className="sight_9_topic_item">
              <h2 className="sight_9_topic_heading">The Role of Continuous Learning in Building a Future-Ready Workplace</h2>
              <ul className="sight_9_topic_list">
                <li>Explore how organizations embracing ongoing learning cultivate agility and resilience.</li>
                <li>Include case studies showing measurable business impact.</li>
              </ul>
            </div>

            <div className="sight_9_topic_item">
              <h2 className="sight_9_topic_heading">How Thought Leaders Foster a Culture of Learning</h2>
              <ul className="sight_9_topic_list">
                <li>Discuss leadership behaviors that model curiosity, experimentation, and knowledge sharing.</li>
                <li>Highlight practical steps to encourage learning across all levels.</li>
              </ul>
            </div>

            <div className="sight_9_topic_item">
              <h2 className="sight_9_topic_heading">⁠⁠Upskilling vs Reskilling: What Every Organization Needs to Know</h2>
              <ul className="sight_9_topic_list">
                <li>Compare approaches and strategies for employee development.</li>
                <li>Show how continuous learning aligns with organizational growth and retention.</li>
              </ul>
            </div>

            <div className="sight_9_topic_item">
              <h2 className="sight_9_topic_heading">Learning Technologies Transforming Workplace Culture</h2>
              <ul className="sight_9_topic_list">
                <li>Cover LMS, AI-driven learning platforms, and microlearning tools.</li>
                <li>Focus on their role in creating accessible and personalized learning experiences.</li>
              </ul>
            </div>

            <div className="sight_9_topic_item">
              <h2 className="sight_9_topic_heading">Peer-to-Peer Learning: Unlocking Collective Knowledge</h2>
              <ul className="sight_9_topic_list">
                <li>Highlight mentorship programs, knowledge-sharing sessions, and communities of practice.</li>
                <li>Emphasize collaboration as a driver for innovation and culture building.</li>
              </ul>
            </div>

            <div className="sight_9_topic_item">
              <h2 className="sight_9_topic_heading">⁠Measuring the Impact of Continuous Learning on Performance</h2>
              <ul className="sight_9_topic_list">
                <li>Suggest KPIs and metrics to assess learning effectiveness.</li>
                <li>Include insights on linking learning initiatives to business outcomes.</li>
              </ul>
            </div>

            <div className="sight_9_topic_item">
              <h2 className="sight_9_topic_heading">Overcoming Barriers to a Learning Culture</h2>
              <ul className="sight_9_topic_list">
                <li>Address challenges like time constraints, lack of motivation, or limited resources.</li>
                <li>Provide strategies to integrate learning seamlessly into daily work.</li>
              </ul>
            </div>

            <div className="sight_9_topic_item">
              <h2 className="sight_9_topic_heading">Thought Leadership in Learning: Trends and Predictions</h2>
              <ul className="sight_9_topic_list">
                <li>Discuss future trends like AI-driven learning, gamification, and adaptive learning.</li>
                <li>Position your organization as forward-thinking and proactive.</li>
              </ul>
            </div>

            <div className="sight_9_topic_item">
              <h2 className="sight_9_topic_heading">The Connection Between Employee Engagement and Continuous Learning</h2>
              <ul className="sight_9_topic_list">
                <li>Show how learning opportunities drive engagement, loyalty, and performance.</li>
                <li>Include real-world examples of culture-driven learning programs.</li>
              </ul>
            </div>

            <div className="sight_9_topic_item">
              <h2 className="sight_9_topic_heading">Storytelling as a Tool for Organizational Learning</h2>
              <ul className="sight_9_topic_list">
                <li>Explore how sharing experiences, successes, and failures strengthens workplace culture.</li>
                <li>Include tips on creating storytelling initiatives that inspire growth.</li>
              </ul>
            </div>

          </div>
        </div>

      </div>
   </div>
    </>
  );
}

export default BlogPage;


